export const LOCK = 'LOCK'
export const UNLOCK = 'UNLOCK'
export const SHOW_SIDEBAR = 'SHOW_SIDEBAR'
export const HIDE_SIDEBAR = 'HIDE_SIDEBAR'
export const SET_VIEW_ID = 'SET_VIEW_ID'
export const RESET_VIEW_PARENTS = 'RESET_VIEW_PARENTS'
export const SET_VIEW_ANIMATION = 'SET_VIEW_ANIMATION'
export const SET_VIEW_PARENTS = 'SET_VIEW_PARENTS'
